import { useTranslation } from "next-i18next";

import { ProductBySlugNonNullable } from "@/common/contracts/pdp.contracts";
import { formatDateWithLocale } from "@/common/utils/intl.utils";
import { useContentLocale } from "@/i18n/hooks";
import { Helper } from "@/ui/typography/Helper";

type ProductDetailsInfoSellerDateProps = {
  product: ProductBySlugNonNullable;
};

export const ProductDetailsInfoSellerDate = ({
  product,
}: ProductDetailsInfoSellerDateProps) => {
  const { t } = useTranslation();
  const locale = useContentLocale();

  const merchant = product.merchant;
  const numberOfSells = merchant.number_of_sells ?? 0;

  const merchantCreatedAt = formatDateWithLocale(
    merchant.created,
    "MMMM YYYY",
    locale
  );

  const sales = t(
    numberOfSells === 1
      ? "pdp:pdp-seller-block-sales.one"
      : "pdp:pdp-seller-block-sales.other",
    {
      0: numberOfSells,
    }
  );

  const dateLabel = `${merchantCreatedAt} • ${sales}`;

  return (
    <Helper color="muted" className="text-md flex items-center">
      {t("pdp:pdp-seller-block-since", { 0: dateLabel })}
    </Helper>
  );
};
